import { render } from "./SamplesManualsPage.vue?vue&type=template&id=37677e96&scoped=true"
import script from "./SamplesManualsPage.vue?vue&type=script&lang=js"
export * from "./SamplesManualsPage.vue?vue&type=script&lang=js"

import "./SamplesManualsPage.vue?vue&type=style&index=0&id=37677e96&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37677e96"]])

export default __exports__